module.exports = __webpack_public_path__ + "img/IMG_1984.abb7f05b.jpg";